import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FiHeart,
  FiActivity,
  FiDroplet,
  FiThermometer,
  FiTrendingUp,
  FiTrendingDown,
  FiFileText,
} from "react-icons/fi";
import OurLayouts from "../../layout";
import { MapPin, Phone, User, ShoppingCart, X, Minus, Pill } from "lucide-react";
import { Tabs, Modal, Radio, Select } from "antd";
import { APP_ROUTES } from "../../../constants/approutes";
import packed from "../../../assets/Tracking/packed.svg";
import YTP from "../../../assets/Tracking/yettopack.svg";
import OFD from "../../../assets/Tracking/outfordelivery.svg";

import eye from "../../../assets/Tracking/eyephar.svg";
import Shipped from "../../../assets/Tracking/Shipped.svg";
import Delivered from "../../../assets/Tracking/Delivered.svg";
import demoLab from "../../../assets/Tracking/demoLab.svg";
import demomed from "../../../assets/Tracking/Medicines.jpg";
import surgeryicon from "../../../assets/surgeryinewcon.svg";
import TrackingModal from "../TrackingModal";
import point from "../../../assets/point.svg";

import { DatePicker, Button } from "antd";
import { Collapse } from "antd";
import VitalDetails from "../../PatientRegister/VitalDetails";
import VerifyAbhaModal from "../../ABHA/VerifyAbhaModal";
import CreateAbhaModal from "../../ABHA/CreateAbhaModal";
import { toast } from "react-toastify";
import { Shield, CheckCircle, Plus } from "lucide-react";
import { format } from "date-fns";
import customericon from "../../../assets/Customer.svg";
import TrackEnquiry from "../TrackEnquiry";
import OrderDetailsModal, {
  OrderDetailsSection,
  OrderDetailsTable,
  SurgeryEnquiryCards,
  orderTableCellClass,
  orderTableHeadClass,
} from "../../shared/OrderDetailsModal";
const { Panel } = Collapse;

const { RangePicker } = DatePicker;

const { TabPane } = Tabs;
const { Option } = Select;
const orders = Array(6).fill({
  id: "00589631",
  pharmacyName: "Rajniamil Medicines",
  date: "14/07/25",
  time: "2:30 PM",
  price: "₹180",
  status: "Order Created",
});
const orders1 = Array(6).fill({
  labLogo: "https://example.com/logo.png",
  labName: "Redcliffe Lifetech Private Limited",
  orderNo: "00569200",
  date: "14/07/25, 2:30 PM",
  orderId: "00569200",
  amount: "220",
  packageName: "Special Full Body Package",
  category: "Pathology",
  discount: "No Discount",
});
const tabStyle = {
  vitals: { color: "#00897b", fontWeight: 700 },
  medical: { color: "#00897b", fontWeight: 700 },
  appointments: { color: "#00897b", fontWeight: 700 },
};

const API_BASE = process.env.REACT_APP_API_URL;

const vitalsColors = {
  temperature: { bg: "bg-green-50", text: "text-green-600" },
  respirationRate: { bg: "bg-cyan-50", text: "text-cyan-700" },
  bloodPressure: { bg: "bg-green-50", text: "text-green-600" },
  oxygenLevel: { bg: "bg-cyan-50", text: "text-cyan-700" },
  heartRate: { bg: "bg-green-50", text: "text-green-600" },
  height: { bg: "bg-cyan-50", text: "text-cyan-700" },
  weight: { bg: "bg-green-50", text: "text-green-600" },
  bloodSugar: { bg: "bg-cyan-50", text: "text-cyan-700" },
};

function PatientInfoCard({ patient, onAbhaVerified }) {
  const disabledFeatures = JSON.parse(localStorage.getItem("disabledFeatures") || "[]");
  const [showAbhaModal, setShowAbhaModal] = useState(false);
  const [showCreateAbhaModal, setShowCreateAbhaModal] = useState(false);
  const [isAbhaVerified, setIsAbhaVerified] = useState(
    !!(patient.abhaNumber && patient.preferredAbhaAddress)
  );

  const handleAbhaSuccess = (abhaData) => {
    console.log("ABHA verified successfully:", abhaData);
    toast.success("ABHA verified successfully!");
    setIsAbhaVerified(true);
    setShowAbhaModal(false);

    // Call the parent callback to update patient data
    if (onAbhaVerified) {
      onAbhaVerified(abhaData);
    }
  };

  const handleCreateAbhaSuccess = (abhaData) => {
    console.log("ABHA created successfully:", abhaData);
    toast.success("ABHA created successfully!");
    setShowCreateAbhaModal(false);
    setIsAbhaVerified(true);

    // Call the parent callback to update patient data
    if (onAbhaVerified) {
      onAbhaVerified(abhaData);
    }
  };

  return (
    <>
      <div className="p-6 bg-[#f4fbf994]">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-xl shadow-md p-6 flex flex-col lg:flex-row lg:gap-6">
            {/* Left Section - Patient Info */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 flex-1">
              {/* Avatar */}
              <div className="flex justify-center sm:justify-start mb-4 sm:mb-0">
                <div className="bg-[#009e7c3d] rounded-full w-16 mt-[-68px] h-16 flex items-center justify-center shadow-sm border-2 border-[#009e7c30]">
                  <User className="w-10 h-10 text-white" />
                </div>
              </div>

              {/* Patient Information */}
              <div className="flex-1 text-center sm:text-left">
                <h2 className="text-3xl font-bold text-[#00897b] mb-2">
                  {patient.firstName} {patient.lastName}
                </h2>
                <p className="text-gray-600 text-base mb-4">
                  {patient.age} years • {patient.gender}
                </p>

                <div className="space-y-3">
                 
                  <div className="flex items-center justify-center sm:justify-start gap-2 text-gray-700">
                    <Phone className="w-4 h-4 text-[#00897b]" />
                    <a
                      href={`tel:${patient.mobileNumber}`}
                      className="text-sm text-black hover:text-[#004276] underline"
                    >
                      {patient.mobileNumber}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section - ABHA Card */}
            {!disabledFeatures.includes("ABDM") && (
            <div className="lg:w-80 mt-6 lg:mt-0">
              {isAbhaVerified ? (
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4 h-full">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                        <Shield className="w-5 h-5 text-green-600" />
                      </div>
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <CheckCircle className="w-4 h-4 text-green-600" />
                          <span className="text-green-700 font-semibold text-sm">
                            ABHA Verified
                          </span>
                        </div>
                        <div className="text-xs text-green-600">
                          Ayushman Bharat Health Account
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pt-3 border-t border-green-200">
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">ABHA Number:</span>
                        <span className="font-mono text-green-700 bg-green-100 px-2 py-1 rounded text-xs">
                          {patient.abhaNumber}
                        </span>
                      </div>
                      {patient.preferredAbhaAddress && (
                        <div className="flex justify-between items-start">
                          <span className="text-gray-600">ABHA Address:</span>
                          <span className="font-mono text-green-700 bg-green-100 px-2 py-1 rounded text-xs max-w-[180px] break-all">
                            {patient.preferredAbhaAddress}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-4 h-full">
                  <div className="flex flex-col h-full">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <Shield className="w-5 h-5 text-[#004276]" />
                      </div>
                      <div>
                        <div className="text-[#004276] font-semibold text-sm mb-1">
                          ABHA Not Verified
                        </div>
                        <div className="text-xs text-[#004276]">
                          Secure your health records with ABHA
                        </div>
                      </div>
                    </div>
                    <div className="mt-auto">
                      <button
                        type="button"
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-[#004276] text-white text-sm rounded-lg hover:bg-[#004276] transition duration-200 font-medium"
                        onClick={() => setShowAbhaModal(true)}
                      >
                        Verify Now
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            )}
          </div>
        </div>
      </div>

      {/* ABHA Modals */}
      <VerifyAbhaModal
        visible={showAbhaModal}
        onClose={() => setShowAbhaModal(false)}
        mobileNumber={patient.mobileNumber}
        onSuccess={handleAbhaSuccess}
        onCreateAbha={() => {
          setShowAbhaModal(false);
          setShowCreateAbhaModal(true);
        }}
      />

      {showCreateAbhaModal && (
        <CreateAbhaModal
          isOpen={showCreateAbhaModal}
          onClose={() => setShowCreateAbhaModal(false)}
          initialMobileNumber={patient.mobileNumber}
          showAsModal={true}
          onSuccess={handleCreateAbhaSuccess}
        />
      )}
    </>
  );
}

function VitalCard({ label, value, icon, colorClass, onViewAll }) {
  return (
    <div className={`${colorClass} rounded-lg p-4 w-full shadow-md`}>
      <div className="text-xl mb-2">{icon}</div>
      <div className="font-semibold text-sm">{label}</div>
      <div className="text-lg font-bold">{value}</div>
      <div className="mt-2 text-right">
        <button
          className="text-[#004276] hover:underline text-sm font-semibold"
          onClick={onViewAll}
        >
          View All
        </button>
      </div>
    </div>
  );
}

export default function PatientDetails() {
  const { state } = useLocation();
  const disabledFeatures = JSON.parse(localStorage.getItem("disabledFeatures") || "[]");
  const patientCode = state?.patientCode;
  const curebayPatientId = state?.curebayPatientId;
  console.log("Received curebayPatientId:", curebayPatientId);
  const [patient, setPatient] = useState(null);
  const [vitals, setVitals] = useState([]);
  const [history, setHistory] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [appointmentSubTab, setAppointmentSubTab] = useState("empanelled");
  const [curebayReferralAppointments, setCurebayReferralAppointments] = useState([]);
  const [curebayReferralLoading, setCurebayReferralLoading] = useState(false);
  const [curebayReferralPage, setCurebayReferralPage] = useState(1);
  const [curebayReferralTotal, setCurebayReferralTotal] = useState(0);
  const [curebayMedicineModalOpen, setCurebayMedicineModalOpen] = useState(false);
  const [curebayMedicineLoading, setCurebayMedicineLoading] = useState(false);
  const [curebayMedicineAdding, setCurebayMedicineAdding] = useState(false);
  const [curebayDrugList, setCurebayDrugList] = useState([]);
  const [curebaySelectedDrugs, setCurebaySelectedDrugs] = useState({});
  const [curebayOrderAppt, setCurebayOrderAppt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isModalVisible3, setIsModalVisible3] = useState(false);
  const [ticketdata, setTicketdata] = useState();
  const [docModalVisible, setDocModalVisible] = useState(false);
  const [docUrl, setDocUrl] = useState("");
  const [isPdf, setIsPdf] = useState(false);
  const [digitalprescription, setDigitalprescription] = useState([]);
  const navigate = useNavigate();
  const [orderType, setOrderType] = useState("pharmacy");
  const [labCategory, setLabCategory] = useState("pathology");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  // Add these state variables near your other useState declarations
  const [pharmacyOrders, setPharmacyOrders] = useState([]);
  const [labOrders, setLabOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [ordersError, setOrdersError] = useState("");
  const [radiologyOrders, setRadiologyorders] = useState([]);
  const [surgeryOrders, setSurgeryOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedSurgeryOrder, setSelectedSurgeryOrder] = useState(null);
  const [isSurgeryModalVisible, setIsSurgeryModalVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState({
    orderId: "",
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [selectedOrder2, setSelectedOrder2] = useState(null);
  const [patientAddresses, setPatientAddresses] = useState([]);
  const [addressesLoading, setAddressesLoading] = useState(false);
  
  // Edit address modal states
  const [editAddressModalOpen, setEditAddressModalOpen] = useState(false);
  const [addAddressModalOpen, setAddAddressModalOpen] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState(null);
  const [editHouseNo, setEditHouseNo] = useState("");
  const [editAddress1, setEditAddress1] = useState("");
  const [editPincode, setEditPincode] = useState("");
  const [editFetchedState, setEditFetchedState] = useState("");
  const [editFetchedCountry, setEditFetchedCountry] = useState("India");
  const [editErrors, setEditErrors] = useState({});
   const hospitalId = localStorage.getItem("hospitalid") || "";
     const GOOGLE_API_URL = process.env.REACT_APP_API_GOOGLE_URL || "";
  
  // Delete confirmation modal state
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const handleViewDetails2 = (order) => {
    setSelectedOrder2(order);
    setIsModalVisible2(true);
  };
  useEffect(() => {
    if (patientCode) {
      fetchOrders();
    }
  }, [filters, orderType]);
  //orderType, labCategory, patientCode, dateRange,
  const fetchOrders = async () => {
    setOrdersLoading(true);
    setOrdersError("");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");

    try {
      let url = "";
      if (orderType === "pharmacy") {
        // url = `${API_BASE}orders?orderType=pharmacy&patientId=${patientCode}&page=0&size=10`;
        url =
          `${API_BASE}orders?orderType=pharmacy&patientId=${patientCode}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=0&size=50`;
      } else if (orderType === "Pathology") {
        url =
          `${API_BASE}orders?orderType=lab&subServiceType=pathology&patientId=${patientCode}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=0&size=50`;
        // url = `${API_BASE}orders?orderType=lab&subServiceType=pathology&patientId=${patientCode}&page=0&size=10`;
      } else if (orderType === "Radiology") {
        url =
          `${API_BASE}orders?orderType=lab&subServiceType=radiology&patientId=${patientCode}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=0&size=50`;
      } else if (orderType === "Surgery") {
        url =
          `${API_BASE}orders?orderType=surgery&patientId=${patientCode}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=0&size=50`;
      }

      if (!url) {
        setOrdersLoading(false);
        return;
      }

      if (dateRange && dateRange[0] && dateRange[1]) {
        const startDate = dateRange[0].format("YYYY-MM-DD");
        const endDate = dateRange[1].format("YYYY-MM-DD");
        url += `&fromDate=${startDate}&toDate=${endDate}`;
      }

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
      });
      console.log(response);

      if (orderType === "pharmacy") {
        setPharmacyOrders(response.data || []);
      } else if (orderType === "Pathology") {
        setLabOrders(response.data || []);
      } else if (orderType === "Radiology") {
        setRadiologyorders(response.data || []);
      } else if (orderType === "Surgery") {
        setSurgeryOrders(response.data || []);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setOrdersError("Failed to load orders");
    } finally {
      setOrdersLoading(false);
    }
  };

  // Fetch patient addresses
  const fetchPatientAddresses = async () => {
    if (!patientCode) return;
    
    setAddressesLoading(true);
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    
    try {
      const response = await axios.get(
        `${API_BASE}addressbook/getBy?patientId=${patientCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      
      console.log("Addresses fetched:", response.data);
      setPatientAddresses(response.data || []);
    } catch (error) {
      console.error("Error fetching addresses:", error);
      setPatientAddresses([]);
    } finally {
      setAddressesLoading(false);
    }
  };

  // Fetch address details by pincode for edit modal
  const fetchEditAddressByPincode = async (pincode) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
      );
      console.log(response.data.data,"ugbhhbhjbhjbhj")
       if (response.data && response.data.data[0] && response.data.status === 200) {
         const addressData = response.data.data[0]; 
         console.log(addressData,"addressData")
         console.log("State value:", addressData.state); // lowercase 's'
         setEditFetchedState(addressData.state); // lowercase 's'
         setEditFetchedCountry("India");
         
         console.log("Address fields updated:", {
           state: addressData.state,
           country: "India"
         });
       } else {
         // Fallback to default values
         setEditFetchedState("");
         setEditFetchedCountry("India");
       }
    } catch (error) {
      console.error("Error fetching address details:", error);
      // Set default values on error
      setEditFetchedState("");
      setEditFetchedCountry("India");
    }
  };

  // Handle edit address submission
  const handleEditAddressSubmit = async () => {
    // Validation
    const errors = {};
    if (!editHouseNo.trim()) errors.houseNo = "House number is required";
    if (!editAddress1.trim()) errors.address1 = "Landmark is required";
    if (!editPincode.trim()) errors.pincode = "Pincode is required";
    if (editPincode.length !== 6) errors.pincode = "Pincode must be 6 digits";

    if (Object.keys(errors).length > 0) {
      setEditErrors(errors);
      return;
    }

    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const payload = {
        address: editHouseNo,
        landmark: editAddress1,
        state: editFetchedState || "",
        pincode: editPincode,
        country: editFetchedCountry || "India",
        patientId: patientCode,
      };

      let response;
      
      // Check if we're adding a new address or updating an existing one
      if (addressToEdit && addressToEdit.id) {
        // Update existing address
        response = await axios.put(
          `${API_BASE}addressbook/${addressToEdit.id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
        
        console.log("Address updated successfully:", response.data);
        
        if (response.data && response.data.id) {
          // Update the address in the list
          setPatientAddresses(prev => 
            prev.map(addr => 
              addr.id === addressToEdit.id 
                ? { ...addr, ...payload }
                : addr
            )
          );
          
          toast.success("Address updated successfully!");
        }
      } else {
        // Add new address
        response = await axios.post(
          `${API_BASE}addressbook`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );
        
        console.log("Address added successfully:", response.data);
        
        if (response.data && response.data.id) {
          // Add the new address to the list
          setPatientAddresses(prev => [...prev, { ...payload, id: response.data.id }]);
          
          toast.success("Address added successfully!");
        }
      }
      
      // Reset form and close modal
      setEditAddressModalOpen(false);
      setAddAddressModalOpen(false);
      setAddressToEdit(null);
      setEditErrors({});
      
      // Reset form fields
      setEditHouseNo("");
      setEditAddress1("");
      setEditPincode("");
      setEditFetchedState("");
      setEditFetchedCountry("India");
      
    } catch (error) {
      console.error("Failed to save address:", error);
      toast.error("Failed to save address. Please try again.");
    }
  };

  // Handle delete address
  const handleDeleteAddress = async () => {
    if (!addressToDelete) return;

    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      
      const response = await axios.delete(
        `${API_BASE}addressbook/${addressToDelete.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );

      console.log("Address deleted successfully:", response.data);
      
      // Remove the address from the list
      setPatientAddresses(prev => 
        prev.filter(addr => addr.id !== addressToDelete.id)
      );
      
      toast.success("Address deleted successfully!");
      setDeleteModalOpen(false);
      setAddressToDelete(null);
    } catch (error) {
      console.error("Failed to delete address:", error);
      toast.error("Failed to delete address. Please try again.");
    }
  };
  const fetchCurebayReferralAppointments = async (page = 1) => {
    if (!curebayPatientId) return;
    setCurebayReferralLoading(true);
    try {
      const NEW_DOCTOR_URL = process.env.REACT_APP_NEW_DOCTOR_URL;
      const response = await axios.get(
        `${NEW_DOCTOR_URL}/appointments?patientId=${curebayPatientId}&page=${page}&size=9&allAppointments=true&paymentStatus=SUCCESS&hospitalId=${hospitalId}`,
      );
      const result = response.data;
      setCurebayReferralAppointments(result.data || []);
      setCurebayReferralTotal(result.totalElements || 0);
      setCurebayReferralPage(page);
    } catch (err) {
      console.error("Error fetching CureBay referral appointments:", err);
    } finally {
      setCurebayReferralLoading(false);
    }
  };

  const handleFilterApply = () => {
    // fetchOrders();
  };
  const handleViewAll = (type) => {
    navigate(APP_ROUTES.VIEWVITAL, {
      state: {
        type,
        patientCode,
      },
    });
  };

  const handleAbhaVerified = async (abhaData) => {
    try {
      let abhaNumber = "";
      let preferredAbhaAddress = "";

      // Handle different data structures from verification vs creation
      if (abhaData.abhaProfile) {
        // From verification
        abhaNumber = abhaData.abhaProfile.abhaNumber || "";
        preferredAbhaAddress = abhaData.abhaProfile.preferredAbhaAddress || "";
      } else if (abhaData.healthIdNumber) {
        // From creation
        abhaNumber = abhaData.healthIdNumber || "";
        preferredAbhaAddress = abhaData.preferredAbhaAddress || "";
      }

      // Update patient data in database
      const token = localStorage.getItem("auth_token");
      const updatePayload = {
        firstName: patient.firstName, // Required
        lastName: patient.lastName, // Required
        gender: patient.gender, // Required
        mobileNumber: patient.mobileNumber, // Required
        abhaNumber: abhaNumber, // New ABHA data
        preferredAbhaAddress: preferredAbhaAddress, // New ABHA data
      };
      const tenantId = localStorage.getItem("tenantId");
      const response = await axios.put(
        `${API_BASE}patient/update/${patientCode}`,
        updatePayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );

      if (response.status === 200) {
        // Update local patient state
        setPatient((prev) => ({
          ...prev,
          abhaNumber: abhaNumber,
          preferredAbhaAddress: preferredAbhaAddress,
        }));

        toast.success("Patient ABHA information updated successfully!");
      } else {
        toast.error("Failed to update patient ABHA information");
      }
    } catch (error) {
      console.error("Error updating patient ABHA information:", error);
      toast.error("Failed to update patient ABHA information");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const config = { headers: { Authorization: `Bearer ${token}`, tenantId: tenantId } };

    async function fetchInitialData() {
      try {
        const [pRes, vRes, hRes, aRes, dpRes, fmRes] = await Promise.all([
          axios.get(
            `${API_BASE}patient/search?patientId=${patientCode}`,
            config
          ),
          axios.get(
            `${API_BASE}patient-vitals/by-patient?patientCode=${patientCode}`,
            config
          ),
          axios.get(
            `${API_BASE}patient-medical-history/by-patient?patientCode=${patientCode}`,
            config
          ),
          axios.get(
            `${API_BASE}queue/appointmentlist?patientId=${patientCode}&paymentStatus=SUCCESS`,
            config
          ),
          axios.get(
            `${API_BASE}prescriptions/docs?patientId=${patientCode}`,
            config
          ),
          axios.get(
            `${API_BASE}patient/search?parentCode=${patientCode}`,
            config
          ),
        ]);

        setPatient(pRes?.data.data[0]);
        setVitals(vRes.data.data || []);
        setDigitalprescription(dpRes.data);

        const sortedHistory = (hRes.data.data || []).sort(
          (a, b) => new Date(b.recordTime) - new Date(a.recordTime)
        );
        setHistory(sortedHistory);

        setAppointments(aRes.data.data || []);
        console.log(fmRes,"srdtfcygvubhjnkml")
        setFamilyMembers(fmRes.data.data || []);
      } catch (e) {
        console.error(e);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    }

    if (patientCode) {
      fetchInitialData();
      fetchPatientAddresses();
    } else {
      setError("No patient code provided");
      setLoading(false);
    }
  }, [patientCode]);
  
  // Debug: Monitor state changes
  useEffect(() => {
    console.log("editFetchedState changed to:", editFetchedState);
  }, [editFetchedState]);
  
  useEffect(() => {
    async function fetchOrders() {
      // setLoading(true);
      const token = localStorage.getItem("auth_token");
        const clinicId = localStorage.getItem("clinicId");
      try {
        const resp = await axios.get(
          `${API_BASE}orders/get-all?clinicId=${clinicId}&serviceType=BOOK_SERVICE&patientId=SWANA7777P&pageNumber=1&pageSize=10`,
          {
            headers: {
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(resp.data.data, "esrdtfyghj");
      } catch (err) {
        console.error("Fetch error:", err.response || err);
      } finally {
        // setLoading(false);
      }
    }
    fetchOrders();
  }, []);
  // Fetch a signed URL for any document (medical, prescription, or lab)
  const fetchAndShowDocument = async (fileName) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const response = await fetch(
        `${API_BASE}patient-medical-history/file-url?fileName=${fileName}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
        }
      );
      const result = await response.json();
      if (result.signedUrl) {
        setDocUrl(result.signedUrl);
        setIsPdf(fileName.toLowerCase().endsWith(".pdf"));
        setDocModalVisible(true);
      } else {
        alert("Failed to retrieve document URL");
      }
    } catch (err) {
      alert("Failed to fetch document URL");
    }
  };

  const fetchAndShowDocumentcb = (prescriptionUrl) => {
    if (!prescriptionUrl) return;
    let url;
    if (prescriptionUrl.startsWith("http://") || prescriptionUrl.startsWith("https://")) {
      url = prescriptionUrl;
    } else {
      const base = GOOGLE_API_URL.endsWith("/") ? GOOGLE_API_URL.slice(0, -1) : GOOGLE_API_URL;
      const cleanPath = prescriptionUrl.startsWith("/") ? prescriptionUrl.slice(1) : prescriptionUrl;
      url = cleanPath.includes("curebay-prescription-docs")
        ? `${base}/${cleanPath}`
        : `${base}/curebay-prescription-docs/${cleanPath}`;
    }
    setDocUrl(url);
    setIsPdf(prescriptionUrl.toLowerCase().endsWith(".pdf"));
    setDocModalVisible(true);
  };

  const getCurebayDrugKey = (drug) => drug.id || drug.drugCode || drug.itemCode;

  const handleCurebayOrderMedicine = async (appt) => {
    const visitId = appt.visitId || appt.id;
    if (!visitId) {
      toast.error("Visit ID not found for this appointment");
      return;
    }

    setCurebayMedicineModalOpen(true);
    setCurebayMedicineLoading(true);
    setCurebayDrugList([]);
    setCurebaySelectedDrugs({});
    setCurebayOrderAppt(appt);

    try {
      const NEW_DOCTOR_URL = process.env.REACT_APP_NEW_DOCTOR_URL;
      const accessToken =
        localStorage.getItem("access_token") || localStorage.getItem("auth_token");
      const response = await fetch(`${NEW_DOCTOR_URL}/api/drug/${visitId}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
      });

      if (!response.ok) {
        throw new Error(`Failed with status ${response.status}`);
      }

      const data = await response.json();
      const drugs = Array.isArray(data?.drugList) ? data.drugList : [];

      if (drugs.length === 0) {
        toast.info("No medicines found in prescription");
      }

      setCurebayDrugList(drugs);
      const initialSelected = {};
      drugs.forEach((drug) => {
        const key = getCurebayDrugKey(drug);
        if (!key) return;
        initialSelected[key] = {
          checked: true,
          quantity: Number(drug.quantity) > 0 ? Number(drug.quantity) : 1,
          drug,
        };
      });
      setCurebaySelectedDrugs(initialSelected);
    } catch (err) {
      console.error("Error fetching prescription drugs:", err);
      toast.error("Failed to load medicines");
      setCurebayMedicineModalOpen(false);
    } finally {
      setCurebayMedicineLoading(false);
    }
  };

  const handleCurebayDrugToggle = (key) => {
    setCurebaySelectedDrugs((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        checked: !prev[key]?.checked,
      },
    }));
  };

  const handleCurebayDrugQuantityChange = (key, quantity) => {
    const parsedQty = Math.max(1, parseInt(quantity, 10) || 1);
    setCurebaySelectedDrugs((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        quantity: parsedQty,
      },
    }));
  };

  const handleCurebayDrugQuantityStep = (key, delta) => {
    setCurebaySelectedDrugs((prev) => {
      const current = prev[key];
      if (!current) return prev;
      return {
        ...prev,
        [key]: {
          ...current,
          quantity: Math.max(1, (Number(current.quantity) || 1) + delta),
        },
      };
    });
  };

  const handleCurebayAddMedicinesToCart = async () => {
    const cartPatientId = curebayPatientId || patient?.curebayPatientId || patient?.patientId;
    if (!cartPatientId) {
      toast.error("Patient ID not found");
      return;
    }

    const selectedItems = Object.values(curebaySelectedDrugs).filter((item) => item.checked);
    if (selectedItems.length === 0) {
      toast.error("Please select at least one medicine");
      return;
    }

    const drugCodes = selectedItems
      .map(({ drug }) => drug.drugCode || drug.itemCode)
      .filter(Boolean);

    if (drugCodes.length === 0) {
      toast.error("Selected medicines do not have valid drug codes");
      return;
    }

    setCurebayMedicineAdding(true);
    try {
      const authToken = localStorage.getItem("auth_token");

      const ratesResponse = await fetch(
        `${process.env.REACT_APP_API_ES_URL}medicine/getMedicineRates`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
          },
          body: JSON.stringify(drugCodes),
        }
      );

      if (!ratesResponse.ok) {
        throw new Error("Failed to fetch medicine rates");
      }

      const ratesData = await ratesResponse.json();
      const ratesList = Array.isArray(ratesData) ? ratesData : [];
      const ratesByCode = new Map(ratesList.map((item) => [item.id, item]));

      const cartPayload = selectedItems
        .map(({ drug, quantity }) => {
          const drugCode = drug.drugCode || drug.itemCode || "";
          const rateInfo = ratesByCode.get(drugCode);
          if (!rateInfo) return null;

          return {
            drugCode,
            drugName: rateInfo.medicineName || rateInfo.trimMedicineName || drug.drugName || "",
            drugCategory: rateInfo.drugCategory || drug.drugCategory || "RX",
            medicineTypeOfSell: rateInfo.medicineTypeOfSell || drug.typeOfSell || "",
            medicineType: drug.medicineType || "",
            unitPrice: parseFloat(rateInfo.medicineRate) || 0,
            quantity: parseInt(quantity, 10) || 1,
            prescriptionRequired:
              String(rateInfo.prescriptionRequired || "").toLowerCase() === "yes" ||
              (rateInfo.drugCategory || drug.drugCategory) === "RX",
            patientId: cartPatientId,
            cartType: "MED",
            sourceChannel: "B2C",
          };
        })
        .filter(Boolean);

      if (cartPayload.length === 0) {
        toast.error("Unable to fetch rates for selected medicines");
        return;
      }

      const addResponse = await fetch(
        `${process.env.REACT_APP_CARTURL}medicine/add-multiple`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(cartPayload),
        }
      );

      if (!addResponse.ok) {
        const errorResult = await addResponse.json().catch(() => ({}));
        throw new Error(errorResult.message || "Failed to add medicines to cart");
      }

      toast.success(
        `${cartPayload.length} medicine${cartPayload.length === 1 ? "" : "s"} added to cart`
      );
      setCurebayMedicineModalOpen(false);

      const selectedPatientForCart = {
        ...(patient || {}),
        patientId: patientCode || patient?.patientId,
        patientName: [patient?.firstName, patient?.middleName, patient?.lastName]
          .filter(Boolean)
          .join(" "),
        appointmentId: curebayOrderAppt?.id || curebayOrderAppt?.visitId,
        whenAppointment: curebayOrderAppt?.whenAppointment,
      };

      navigate("/MedicineCartPage", {
        state: {
          patientId: patientCode || patient?.patientId,
          selectedPatient: selectedPatientForCart,
          abdmData: null,
        },
      });
    } catch (err) {
      console.error("Error adding medicines to cart:", err);
      toast.error(err.message || "Something went wrong while adding to cart");
    } finally {
      setCurebayMedicineAdding(false);
    }
  };

  if (loading) {
    return (
      <OurLayouts>
        <div className="p-8 text-center">Loading...</div>
      </OurLayouts>
    );
  }

  if (error) {
    return (
      <OurLayouts>
        <div className="p-8 text-center text-red-600">{error}</div>
      </OurLayouts>
    );
  }
  const handleViewDetails = (order) => {
    setIsModalVisible(true);
    setSelectedOrder(order);
  };
  const handleViewSurgeryDetails = (order) => {
    setSelectedSurgeryOrder(order);
    setIsSurgeryModalVisible(true);
  };
  const handleEnquiry = async (order) => {
    console.log(order, order.patientId, "order");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const hospitalId = localStorage.getItem("hospitalid") || "";
    const response = await axios.get(
      `${API_BASE}patient/search?patientId=${order.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
          },
      }
    );

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        // patientdetailsid: "",
        patientId: order.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob,
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: Patientdata.address || order.address || "",
        pincode: Patientdata.pinCode,
      },
      serviceDetailsMessage: "",
      tickeType: "MEDICINE",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);

        // Make the second API call with the ticket ID from the first response
        const ticketId = Data.data.id;
        const orderId = order.id;

        try {
          const secondRes = await fetch(
            `${API_BASE}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            }
          );

          if (secondRes.ok) {
            // Handle plain text response
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            console.log("Second API response:", responseText);

            // Reload the page to show updated status
            window.location.reload();
          } else {
            // Try to get error message from response
            let errorMessage =
              "Failed to create enquiry. Please try again later.";
            try {
              const errorData = await secondRes.json();
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              // If JSON parsing fails, try text
              try {
                const errorText = await secondRes.text();
                errorMessage = errorText || errorMessage;
              } catch (textError) {
                console.error("Could not parse error response:", textError);
              }
            }
            toast.error(errorMessage);
            console.error("Second API error:", errorMessage);
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
      console.log(Data, "dxfghj");
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };
  const handleEnquiry2 = async (order) => {
    console.log(order, order.patientId, "order");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const hospitalId = localStorage.getItem("hospitalid") || "";
    const response = await axios.get(
      `${API_BASE}patient/search?patientId=${order.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      }
    );

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        // patientdetailsid: "",
        patientId: order.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob,
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: Patientdata.address || order.address || "" ,
        pincode: Patientdata.pinCode,
      },
      serviceDetailsMessage: "",
      tickeType: "LAB_TEST",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);

        // Make the second API call with the ticket ID from the first response
        const ticketId = Data.data.id;
        const orderId = order.id;

        try {
          const secondRes = await fetch(
            `${API_BASE}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            }
          );

          if (secondRes.ok) {
            // Handle plain text response
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            console.log("Second API response:", responseText);

            // Reload the page to show updated status
            window.location.reload();
          } else {
            // Try to get error message from response
            let errorMessage =
              "Failed to create enquiry. Please try again later.";
            try {
              const errorData = await secondRes.json();
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              // If JSON parsing fails, try text
              try {
                const errorText = await secondRes.text();
                errorMessage = errorText || errorMessage;
              } catch (textError) {
                console.error("Could not parse error response:", textError);
              }
            }
            toast.error(errorMessage);
            console.error("Second API error:", errorMessage);
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
      console.log(Data, "dxfghj");
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };
  const handleEnquirySurgery = async (order) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const hospitalId = localStorage.getItem("hospitalid") || "";
    const response = await axios.get(
      `${API_BASE}patient/search?patientId=${order.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      }
    );

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        patientId: order.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob,
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: Patientdata.address || order.address || "",
        pincode: Patientdata.pinCode,
      },
      serviceDetailsMessage: "",
      tickeType: "SURGERY",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);
        const ticketId = Data.data.id;
        const orderId = order.id;

        try {
          const secondRes = await fetch(
            `${API_BASE}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            }
          );

          if (secondRes.ok) {
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            window.location.reload();
          } else {
            toast.error("Failed to create enquiry. Please try again later.");
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };
  const handleTrackOrder = async (order) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const orderNo = order.drugPrescriptions?.drugOrderId;
    const API_NEW_URL = process.env.REACT_APP_API_NEW_URL;
    try {
      const response = await axios.get(
        `${API_NEW_URL}orderloader/order-status?orderNo=${orderNo}`
        // {
        //   headers: {
        //     Accept: "*/*",
        //     // Authorization: `Bearer ${token}`,
        //     tenantId: tenantId,
        //   },
        // }
      );
      console.log(response, "response");
      setTrackingInfo(response.data); // save response to pass to modal
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching tracking info:", error);
    }
  };

  const handleTrackEnquiry = async (order) => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    // Get the first ticket ID from the enquiryTickets array
    const ticketId = order.enquiryTickets[0].ticketId;

    console.log("Calling API with ticketId:", ticketId);
    console.log("Order enquiryTickets:", order.enquiryTickets);

    // Call the API to get ticket details
    const response = await fetch(
      `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/ticket/${ticketId}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",

          },
      }
    );

    console.log("API Response status:", response.status);
    console.log("API Response:", response);

    const ticketData = await response.json();
    setTicketdata(ticketData.data);
    console.log("Ticket details:", ticketData);
    setIsModalVisible3(true);
    // toast.success(`API called successfully! Ticket ID: ${ticketId}`);
  };
  const renderOrderCard = (order, index) => (
    <div
      key={index}
      style={{
        background: "#fff",
        padding: "15px",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        marginBottom: "20px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          <img
            src={demomed}
            alt="order"
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          />
          <div>
            {/* <div className="text-base" style={{ display: "flex", gap: "10px" }}>
            Id:{" "}
              <span className="font-medium text-sm">
                {order.id}
              </span>
            </div> */}
            <p className="text-[#004276] font-normal text-base mb-1">
              <span className="font-medium">Id:</span>{" "}
              <span className="font-medium text-sm">{order.id}</span>{" "}
            </p>
            {/* 
            <div
              style={{ fontSize: "12px", marginTop: 4 }}
            >{`Pharmacy Name: ${order.pharmacyName}`}</div> */}
            <div className="mt-1 text-sm">
              Placed On: {order.createdDate?.split("T")[0]}
            </div>
            <div className="mt-1 text-sm">
              Billing Amount:{order.amount.toFixed(2)}
            </div>
          </div>
          {(!order.enquiryTickets || order.enquiryTickets.length === 0) && (
            <img
              src={customericon}
              alt="Customer"
              title="Customer Support"
              className="cursor-pointer w-8 h-8 ml-7"
              onClick={() => handleEnquiry(order)}
            />
          )}
        </div>
      </div>
      <div className="gap-3 flex justify-between border-[#E2E2E5] mt-3 pt-3 border-t-2">
        <button
          className="bg-[#003F6B] hover:bg-[#002a48] text-white px-2 h-7 rounded-full text-sm font-medium"
          onClick={() => handleTrackOrder(order)}
        >
          Track Order
        </button>
        <button
          className="border border-[#003F6B] hover:bg-[#f0f8ff] text-[#003F6B] px-2 h-7  rounded-full text-sm font-medium"
          onClick={() => handleViewDetails(order)}
        >
          View Details
        </button>
        {order.enquiryTickets && order.enquiryTickets.length > 0 && (
          <button
            className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-2 h-7 rounded-full text-sm font-medium transition-colors duration-200"
            onClick={() => handleTrackEnquiry(order)}
          >
            Track Enquiry
          </button>
        )}
      </div>
    </div>
  );
  const renderOrderCard2 = (order, index) => (
    <div
      style={{
        backgroundColor: "#fff",
        border: "1px solid #E3E3E3",
        borderRadius: "10px",
        padding: "16px",
        boxSizing: "border-box",
        fontFamily: "sans-serif",
        height: "100%",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ marginRight: "16px" }}>
          <img
            src={demoLab}
            alt="Lab Logo"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          {/* <div className="flex justify-between items-start mb-3"> */}
          <div className="items-start mb-3">
            <p className="text-[#004276] font-normal text-base mb-0">
              <span className="font-medium">Order Id:</span>{" "}
              <span className="font-medium text-sm">{order.id}</span>{" "}
            </p>
            <p className="text-[#000] font-normal text-base mb-0">
              <span className="font-medium">Placed On:</span>{" "}
              <span className="font-medium text-sm">
                {" "}
                {new Date(order.createdDate)
                  .toLocaleString("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                  })
                  .replace(",", "")}
              </span>{" "}
            </p>
            <p className="text-[#000] font-normal text-base mb-0">
              <span className="font-medium">Billing Amount:</span>{" "}
              <span className="font-medium text-sm"> {order.amount}</span>{" "}
            </p>

            <div>
              {/* <button
      className="border border-[#003F6B] bg-[#003F6B] text-white px-4 py-2 rounded-full text-sm font-medium"
      onClick={() => handleEnquiry2(order)}
    >
      Enquiry
    </button> */}
            </div>
          </div>

          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "13px",
              color: "#000",
              marginTop: "8px",
            }}
          >
            <span>
              <strong>Placed On:</strong>{" "}
              {new Date(order.createdDate)
                .toLocaleString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                  hour12: false,
                })
                .replace(",", "")}
            </span>
            <span>
              <strong>Order Id:</strong>{" "}
              {order.labTests?.labOrderId}
            </span>
            <span className=" text-[#00B77E]">
              <strong className=" text-slate-900">Amount Paid:</strong> ₹
              {order.amount}
            </span>
          </div> */}
        </div>
      </div>

      <div
        style={{
          borderTop: "1px solid #EEE",
          marginTop: "12px",
          marginBottom: "12px",
        }}
      />

      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "14px",
          fontWeight: 500,
          alignItems: "center",
        }}
      >
        <span style={{ color: "#004A8F" }}>
          {order.labTests?.labTests.map((test, index) => (
            <div key={index}>• {test.labTestName}</div>
          ))}
        </span>
        <span style={{ color: "#222" }}>
          {order.labTests?.labType}
        </span>
        <span style={{ color: "#999" }}>
          {order.labTests?.discountedAmount || "No Discount"}
        </span>
      </div> */}

      <div className="mt-4 flex gap-3 justify-between">
        <button
          className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-[#fff] text-[#003F6B] px-4 py-2 rounded-full text-sm font-medium"
          onClick={() => handleViewDetails2(order)}
        >
          View Details
        </button>
        {(!order.enquiryTickets || order.enquiryTickets.length === 0) && (
          <img
            src={customericon}
            alt="Customer"
            title="Customer Support"
            className="cursor-pointer w-8 h-8"
            onClick={() => handleEnquiry2(order)}
          />
        )}
        {order.enquiryTickets && order.enquiryTickets.length > 0 && (
          <button
            className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200"
            onClick={() => handleTrackEnquiry(order)}
          >
            Track Enquiry
          </button>
        )}
      </div>
    </div>
  );

  const renderSurgeryOrderCard = (order, index) => {
    const surgeryDetails =
      order.surgeryEnquiry && order.surgeryEnquiry.length > 0
        ? order.surgeryEnquiry[0]
        : null;

    return (
      <div
        key={index}
        className="bg-white border border-[#E3E3E3] rounded-[10px] p-4 h-full"
      >
        <div className="flex items-start gap-4">
          <img src={surgeryicon} alt="Surgery" className="w-10 h-10 mt-1" />
          <div className="flex-1">
            <p className="text-[#004276] font-normal text-base mb-0">
              <span className="font-medium">Order Id:</span>{" "}
              <span className="font-medium text-sm">{order.id}</span>
            </p>
            <p className="text-[#000] font-normal text-base mb-0">
              <span className="font-medium">Placed On:</span>{" "}
              <span className="font-medium text-sm">
                {order.createdDate?.split("T")[0]}
              </span>
            </p>
            {surgeryDetails?.procedureName && (
              <p className="text-sm text-gray-700 mb-0 mt-1">
                Procedure: {surgeryDetails.procedureName}
              </p>
            )}
            {surgeryDetails?.hospitalName && (
              <p className="text-sm text-gray-700 mb-0 mt-1">
                Hospital: {surgeryDetails.hospitalName}
              </p>
            )}
          </div>
          {(!order.enquiryTickets || order.enquiryTickets.length === 0) && (
            <img
              src={customericon}
              alt="Customer"
              title="Customer Support"
              className="cursor-pointer w-8 h-8"
              onClick={() => handleEnquirySurgery(order)}
            />
          )}
        </div>

        <div className="mt-4 flex gap-3 justify-between border-t border-[#EEE] pt-3">
          <button
            className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-4 py-2 rounded-full text-sm font-medium"
            onClick={() => handleViewSurgeryDetails(order)}
          >
            View Details
          </button>
          {order.enquiryTickets && order.enquiryTickets.length > 0 && (
            <button
              className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200"
              onClick={() => handleTrackEnquiry(order)}
            >
              Track Enquiry
            </button>
          )}
        </div>
      </div>
    );
  };

  const latestEntry = history[0] || {};
  const onCancel = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    setOpenModal(false);
    const response = await axios.get(
      `${API_BASE}patient-vitals/by-patient?patientCode=${patientCode}`,
      {
        headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
      }
    );
    setVitals(response.data.data || []);
  };
  const handleReset = () => {
    setFilters({
      orderId: "",
      fromDate: format(new Date(), "yyyy-MM-dd"),
      toDate: format(new Date(), "yyyy-MM-dd"),
    });
  };
  const handleSearch = () => {
    fetchOrders();
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <OurLayouts>
      <div className="p-6 max-w-6xl mx-auto bg-[#f4fbf994] min-h-screen">
        <div className="">
          <PatientInfoCard
            patient={patient}
            onAbhaVerified={handleAbhaVerified}
          />
        </div>
        {/* <div className="relative mb-8 mt-8">
          <div className="absolute top-0 right-0 z-10">
            <div className="bg-blue-50 border border-[#00B5E2] rounded-lg px-3 py-2 flex items-center gap-2 shadow-sm">
              <div className="w-4 h-4 bg-[#004276] rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-bold">i</span>
              </div>
              <span className="text-[#004276] text-sm font-medium whitespace-nowrap">
                Latest Data Record:{" "}
                {vitals.length > 0
                  ? new Date(
                      vitals[0].createdDate
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }) +
                    ", " +
                    new Date(
                      vitals[0].createdDate
                    ).toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })
                  : "No data available"}
              </span>
            </div>
          </div>
        </div> */}

        <Tabs defaultActiveKey="1">
          <TabPane tab={<span style={tabStyle.vitals}>Vitals</span>} key="1">
            <div className="flex justify-end mt-4">
              <button
                type="button"
                className="px-6 py-2 rounded-full border border-[#004276] text-[#fff] bg-[#004276] transition font-medium"
                onClick={() => setOpenModal(true)}
              >
                Add Vitals
              </button>
            </div>

            {vitals.length === 0 && <p>No vitals records available.</p>}

            {vitals.length > 0 && (
              <div className="bg-white rounded-lg p-4 shadow mb-4">
                {/* <h4 className="text-lg font-semibold mb-4 text-[#004276]">
                  Latest Vitals Record
                  <span className="text-sm font-normal text-gray-500 ml-2">
                    (
                    {new Date(
                      vitals[0].createdDate
                    ).toLocaleString()}
                    )
                  </span>
                </h4> */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                  <VitalCard
                    label="Temperature"
                    value={`${vitals[0].temperature} °F`}
                    icon={<FiThermometer />}
                    colorClass={`${vitalsColors.temperature.bg} ${vitalsColors.temperature.text}`}
                    onViewAll={() => handleViewAll("temperature")}
                  />
                  <VitalCard
                    label="Respiration Rate"
                    value={`${vitals[0].respirationRate} /min`}
                    icon={<FiActivity />}
                    colorClass={`${vitalsColors.respirationRate.bg} ${vitalsColors.respirationRate.text}`}
                    onViewAll={() => handleViewAll("respirationRate")}
                  />
                  <VitalCard
                    label="Blood Pressure"
                    value={`${vitals[0].bloodPressureSystolic}/${vitals[0].bloodPressureDiastolic} mmHg`}
                    icon={<FiDroplet />}
                    colorClass={`${vitalsColors.bloodPressure.bg} ${vitalsColors.bloodPressure.text}`}
                    onViewAll={() => handleViewAll("bloodPressure")}
                  />
                  <VitalCard
                    label="Oxygen Level"
                    value={`${vitals[0].oxygenLevel} %`}
                    icon={<FiHeart />}
                    colorClass={`${vitalsColors.oxygenLevel.bg} ${vitalsColors.oxygenLevel.text}`}
                    onViewAll={() => handleViewAll("oxygenLevel")}
                  />
                  <VitalCard
                    label="Heart Rate"
                    value={`${vitals[0].heartRate} bpm`}
                    icon={<FiHeart />}
                    colorClass={`${vitalsColors.heartRate.bg} ${vitalsColors.heartRate.text}`}
                    onViewAll={() => handleViewAll("heartRate")}
                  />
                  <VitalCard
                    label="Height"
                    value={
                      vitals[0].heightFeet > 0
                        ? `${vitals[0].heightFeet} ft ${vitals[0].heightInches} in`
                        : `${vitals[0].heightCm} cm`
                    }
                    icon={<FiTrendingUp />}
                    colorClass={`${vitalsColors.height.bg} ${vitalsColors.height.text}`}
                    onViewAll={() => handleViewAll("height")}
                  />
                  <VitalCard
                    label="Weight"
                    value={`${vitals[0].weightInKg} kg`}
                    icon={<FiTrendingDown />}
                    colorClass={`${vitalsColors.weight.bg} ${vitalsColors.weight.text}`}
                    onViewAll={() => handleViewAll("weight")}
                  />
                  <VitalCard
                    label="Blood Glucose"
                    value={`${vitals[0].bloodGlucose} mg/dL`}
                    icon={<FiDroplet />}
                    colorClass={`${vitalsColors.bloodSugar.bg} ${vitalsColors.bloodSugar.text}`}
                    onViewAll={() => handleViewAll("bloodGlucose")}
                  />
                </div>
              </div>
            )}

            {openModal && (
              <Modal
                title={
                  <div
                    style={{
                      backgroundColor: "#e6f7ff",
                      padding: "12px 24px",
                      margin: "-24px -24px 0 -24px",
                    }}
                  >
                    Add Vital
                  </div>
                }
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={null}
                width="75%"
              >
                <VitalDetails
                  patientCode={patientCode}
                  onCancel={onCancel}
                  smartvital={false}
                />
              </Modal>
            )}
          </TabPane>

          <TabPane
            tab={<span style={tabStyle.medical}>Medical Reports</span>}
            key="2"
          >
            {history.length === 0 && <p>No medical history available.</p>}

            {history.length > 0 && (
              <div className="space-y-6">
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h4 className="font-semibold text-gray-700 mb-2">
                    Date: ({new Date(latestEntry.recordTime).toLocaleString()})
                  </h4>
                  <ul className="text-gray-700 text-sm space-y-2">
                    <li>
                      <strong>Allergies:</strong> {latestEntry.allergyHistory}
                    </li>
                    <li>
                      <strong>Medical History:</strong>{" "}
                      {latestEntry.medicalHistory}
                    </li>
                    <li>
                      <strong>Surgical History:</strong>{" "}
                      {latestEntry.surgicalHistory}
                    </li>
                    <li>
                      <strong>Family History:</strong>{" "}
                      {latestEntry.familyHistory}
                    </li>
                    <li>
                      <strong>Social History:</strong>{" "}
                      {latestEntry.socialHistory}
                    </li>
                    <li>
                      <strong>Medication:</strong> {latestEntry.medication}
                    </li>
                    {latestEntry.documentUrl && (
                      <li>
                        <strong>Prescription:</strong>
                        <button
                          onClick={() =>
                            fetchAndShowDocument(latestEntry.documentUrl)
                          }
                          className="text-blue-600 hover:underline text-sm flex items-center gap-1"
                        >
                          <FiFileText className="inline-block" /> View
                          Prescription
                        </button>
                      </li>
                    )}
                    {latestEntry.labReportUrls &&
                      latestEntry.labReportUrls.length > 0 && (
                        <li>
                          <strong>Lab Reports:</strong>
                          <div className="flex flex-col space-y-2 mt-1">
                            {latestEntry.labReportUrls.map(
                              (reportUrl, index) => (
                                <button
                                  key={index}
                                  onClick={() =>
                                    fetchAndShowDocument(reportUrl)
                                  }
                                  className="text-blue-600 hover:underline text-sm flex items-center gap-1"
                                >
                                  <FiFileText className="inline-block" /> View
                                  Lab Report {index + 1}
                                </button>
                              )
                            )}
                          </div>
                        </li>
                      )}
                  </ul>
                </div>

                {history.length > 1 && (
                  <details className="bg-white rounded-lg p-4 shadow">
                    <summary className="cursor-pointer text-blue-600 font-medium mb-3">
                      Show older medical history
                    </summary>
                    <div className="space-y-6 mt-3">
                      {history.slice(1).map((entry, idx) => (
                        <div
                          key={entry.id || idx}
                          className="bg-white rounded-lg p-4 shadow"
                        >
                          <h4 className="font-semibold text-gray-700 mb-2">
                            Date: ({" "}
                            {new Date(entry.recordTime).toLocaleString()})
                          </h4>
                          <ul className="text-gray-700 text-sm space-y-2">
                            <li>
                              <strong>Allergies:</strong> {entry.allergyHistory}
                            </li>
                            <li>
                              <strong>Medical History:</strong>{" "}
                              {entry.medicalHistory}
                            </li>
                            <li>
                              <strong>Surgical History:</strong>{" "}
                              {entry.surgicalHistory}
                            </li>
                            <li>
                              <strong>Family History:</strong>{" "}
                              {entry.familyHistory}
                            </li>
                            <li>
                              <strong>Social History:</strong>{" "}
                              {entry.socialHistory}
                            </li>
                            <li>
                              <strong>Medication:</strong> {entry.medication}
                            </li>
                            {entry.documentUrl && (
                              <li>
                                <strong>Prescription:</strong>
                                <button
                                  onClick={() =>
                                    fetchAndShowDocument(entry.documentUrl)
                                  }
                                  className="text-blue-600 hover:underline text-sm flex items-center gap-1"
                                >
                                  <FiFileText className="inline-block" /> View
                                  Prescription
                                </button>
                              </li>
                            )}
                            {entry.labReportUrls &&
                              entry.labReportUrls.length > 0 && (
                                <li>
                                  <strong>Lab Reports:</strong>
                                  <div className="flex flex-col space-y-2 mt-1">
                                    {entry.labReportUrls.map(
                                      (reportUrl, index) => (
                                        <button
                                          key={index}
                                          onClick={() =>
                                            fetchAndShowDocument(reportUrl)
                                          }
                                          className="text-blue-600 hover:underline text-sm flex items-center gap-1"
                                        >
                                          <FiFileText className="inline-block" />{" "}
                                          View Lab Report {index + 1}
                                        </button>
                                      )
                                    )}
                                  </div>
                                </li>
                              )}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </details>
                )}
              </div>
            )}
          </TabPane>

          <TabPane
            tab={<span style={tabStyle.appointments}>Appointment Details</span>}
            key="3"
          >
            {/* Sub-tab toggle */}
            <div className="flex justify-end mt-2 mb-5">
              <div className="inline-flex bg-gray-100 rounded-xl p-1 gap-1">
                <button
                  onClick={() => setAppointmentSubTab("empanelled")}
                  className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all ${
                    appointmentSubTab === "empanelled"
                      ? "bg-white text-[#004276] shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Empanelled Doctors
                </button>
                <button
                  onClick={() => {
                    setAppointmentSubTab("curebay");
                    if (curebayReferralAppointments.length === 0) fetchCurebayReferralAppointments(1);
                  }}
                  className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-all ${
                    appointmentSubTab === "curebay"
                      ? "bg-white text-[#00897b] shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  CureBay Referral
                </button>
              </div>
            </div>

            {/* Empanelled Doctors Booking */}
            {appointmentSubTab === "empanelled" && (
              <>
                {appointments.filter(a => a.status === "COMPLETED" || a.status === "SKIPPED").length === 0 ? (
                  <div className="text-center py-12 text-gray-400">No appointments on record.</div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {appointments
                      .filter(a => a.status === "COMPLETED" || a.status === "SKIPPED")
                      .map((appt) => {
                        const hasPrescription = appt.prescriptionStatus === "Y" && !!appt.prescriptionDoc;
                        const isSkipped = appt.status === "SKIPPED";
                        const isCompleted = !isSkipped && hasPrescription;
                        const accentColor = isSkipped ? "#6b7280" : isCompleted ? "#21AA6A" : "#e07b2a";
                        const statusLabel = isSkipped ? "Skipped" : isCompleted ? "Completed" : "Pending";
                        const nameParts = (appt.doctorName || "").trim().split(" ");
                        const initials = ((nameParts[0]?.[0] || "") + (nameParts[nameParts.length - 1]?.[0] || "")).toUpperCase();
                        const dateStr = new Date(appt.whenAppointment).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
                        return (
                          <div key={appt.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow flex flex-col">
                            <div style={{ height: 4, background: accentColor }} />

                            {/* Doctor header */}
                            <div className="flex items-center justify-between px-4 pt-4 pb-3">
                              <div className="flex items-center gap-3">
                                <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white font-bold text-sm flex-shrink-0" style={{ background: "#1a3f6f" }}>
                                  {initials || "Dr"}
                                </div>
                                <div>
                                  <p className="font-bold text-[#1a3f6f] text-sm leading-tight">{appt.doctorName || "N/A"}</p>
                                  <p className="text-xs text-gray-500 mt-0.5">Token: {appt.tokenNumber}</p>
                                </div>
                              </div>
                              <span className="text-xs font-semibold whitespace-nowrap ml-2" style={{ color: accentColor }}>
                                {statusLabel}
                              </span>
                            </div>

                            <div className="border-t border-gray-100 mx-4" />

                            {/* Body */}
                            <div className="px-4 py-3 flex-1 space-y-3">
                              <div>
                                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Appointment Slot</p>
                                <div className="flex items-center gap-1.5">
                                  <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><rect x="3" y="4" width="18" height="18" rx="2" strokeWidth="1.5"/><path strokeWidth="1.5" d="M16 2v4M8 2v4M3 10h18"/></svg>
                                  <span className="text-sm text-gray-700 font-medium">{dateStr} | {appt.fromTime} - {appt.toTime}</span>
                                </div>
                              </div>

                              <div>
                                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Reason</p>
                                <div className="flex items-center gap-1.5">
                                  <svg className="w-4 h-4 text-orange-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeWidth="1.5" d="M9 12h6M9 16h6M7 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2M9 4a2 2 0 002 2h2a2 2 0 002-2M9 4a2 2 0 012-2h2a2 2 0 012 2"/></svg>
                                  <span className="text-sm font-semibold text-gray-800">{appt.consultationsReason || "N/A"}</span>
                                </div>
                              </div>

                              <div>
                                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Payment</p>
                                <div className="flex items-center gap-1.5">
                                  <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><rect x="2" y="5" width="20" height="14" rx="2" strokeWidth="1.5"/><path strokeWidth="1.5" d="M2 10h20"/></svg>
                                  <span className="text-sm text-gray-700 font-medium">
                                    {appt.payMode?.toLowerCase() === "digital" ? "Digital Payment" : appt.payMode || "N/A"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Footer - prescription */}
                            <div className="border-t border-gray-100 px-4 py-3">
                              {hasPrescription ? (
                                <button
                                  onClick={() => fetchAndShowDocument(appt.prescriptionDoc)}
                                  className="flex items-center gap-1.5 text-xs font-semibold text-white bg-[#004276] hover:bg-[#003057] px-4 py-1.5 rounded-full transition-colors"
                                >
                                  <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeWidth="2" d="M9 12h6M9 16h6M7 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2M9 4a2 2 0 002 2h2a2 2 0 002-2M9 4a2 2 0 012-2h2a2 2 0 012 2"/></svg>
                                  View Prescription
                                </button>
                              ) : (
                                <span className="text-xs text-gray-400">No prescription available</span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </>
            )}

            {/* CureBay Referral Booking */}
            {appointmentSubTab === "curebay" && (
              <>
                {curebayReferralLoading ? (
                  <div className="flex justify-center items-center py-16">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00897b]"></div>
                    <span className="ml-3 text-gray-500">Loading referral appointments...</span>
                  </div>
                ) : curebayReferralAppointments.length === 0 ? (
                  <div className="text-center py-12 text-gray-400">No CureBay referral appointments found.</div>
                ) : (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                      {curebayReferralAppointments.map((appt) => {
                        const isCompleted = !!appt.prescriptionUrl;
                        const isUpcoming = appt.status === 1 && !appt.prescriptionUrl;
                        const accentColor = isUpcoming ? "#1a3f6f" : isCompleted ? "#21AA6A" : "#e07b2a";
                        const initials = `${appt.doctorFirstName?.[0] || ""}${appt.doctorLastName?.[0] || ""}`.toUpperCase();
                        const dateStr = new Date(appt.whenAppointment).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
                        const patientName = `${appt.salutation} ${appt.firstName} ${appt.lastName}`;
                        return (
                          <div key={appt.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow flex flex-col">
                            {/* Top colored border */}
                            <div style={{ height: 4, background: accentColor }} />

                            {/* Doctor header */}
                            <div className="flex items-center justify-between px-4 pt-4 pb-3">
                              <div className="flex items-center gap-3">
                                <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white font-bold text-sm flex-shrink-0" style={{ background: "#1a3f6f" }}>
                                  {initials}
                                </div>
                                <div>
                                  <p className="font-bold text-[#1a3f6f] text-sm leading-tight">
                                    {appt.doctorSalutation} {appt.doctorFirstName} {appt.doctorLastName}
                                  </p>
                                  <p className="text-xs text-gray-500 mt-0.5 mb-2">
                                    {appt.doctorSpeciality} · {appt.doctorQualification}
                                  </p>
                                  <p className="text-xs text-gray-500 mt-0">
                                    Appointment No.: {appt.id}
                                  </p>
                                </div>
                              </div>
                              <span className="text-xs font-semibold whitespace-nowrap ml-2" style={{ color: accentColor }}>
                                {isUpcoming ? "Upcoming" : isCompleted ? "Completed" : "Pending"}
                              </span>
                            </div>

                            <div className="border-t border-gray-100 mx-4" />

                            {/* Body */}
                            <div className="px-4 py-3 flex-1 space-y-3">
                              {/* Patient + Type row */}
                              <div className="grid grid-cols-2 gap-3">
                                <div>
                                  <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Patient</p>
                                  <div className="flex items-center gap-1.5">
                                    <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="8" r="4" strokeWidth="1.5"/><path strokeWidth="1.5" d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
                                    <span className="text-sm text-gray-700 font-medium truncate">{patientName}</span>
                                  </div>
                                </div>
                                <div>
                                  <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Type</p>
                                  <div className="flex items-center gap-1.5">
                                    <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><rect x="2" y="7" width="15" height="10" rx="2" strokeWidth="1.5"/><path strokeWidth="1.5" d="M17 10l5-3v10l-5-3"/></svg>
                                    <span className="text-sm text-gray-700 font-medium">{appt.consultationsType === "V" ? "Video" : "In-Person"}</span>
                                  </div>
                                </div>
                              </div>

                              {/* Appointment Slot */}
                              <div>
                                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Appointment Slot</p>
                                <div className="flex items-center gap-1.5">
                                  <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><rect x="3" y="4" width="18" height="18" rx="2" strokeWidth="1.5"/><path strokeWidth="1.5" d="M16 2v4M8 2v4M3 10h18"/></svg>
                                  <span className="text-sm text-gray-700 font-medium">{dateStr} | {appt.fromTime} - {appt.toTime}</span>
                                </div>
                              </div>
                              
                              {/* Reason */}
                              <div>
                                <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Reason</p>
                                <div className="flex items-center gap-1.5">
                                  <svg className="w-4 h-4 text-orange-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeWidth="1.5" d="M9 12h6M9 16h6M7 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2M9 4a2 2 0 002 2h2a2 2 0 002-2M9 4a2 2 0 012-2h2a2 2 0 012 2"/></svg>
                                  <span className="text-sm font-semibold text-gray-800">{appt.consultationsReason || "N/A"}</span>
                                </div>
                              </div>
                            </div>

                            {/* Footer - prescription */}
                            <div className="border-t border-gray-100 px-4 py-3">
                              {appt.prescriptionUrl ? (
                                <div className="flex flex-wrap items-center gap-2">
                                  <button
                                    onClick={() => fetchAndShowDocumentcb(appt.prescriptionUrl)}
                                    className="flex items-center gap-1.5 text-xs font-semibold text-white bg-[#004276] hover:bg-[#003057] px-4 py-1.5 rounded-full transition-colors"
                                  >
                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeWidth="2" d="M9 12h6M9 16h6M7 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2M9 4a2 2 0 002 2h2a2 2 0 002-2M9 4a2 2 0 012-2h2a2 2 0 012 2"/></svg>
                                    View Prescription
                                  </button>
                                  <button
                                    onClick={() => handleCurebayOrderMedicine(appt)}
                                    className="flex items-center gap-1.5 text-xs font-semibold text-[#004276] border border-[#004276] hover:bg-[#004276] hover:text-white px-4 py-1.5 rounded-full transition-colors"
                                  >
                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeWidth="2" d="M8 8h8v8H8z" transform="rotate(45 12 12)"/><path strokeWidth="2" d="M12 6v12M6 12h12"/></svg>
                                    Order Medicine
                                  </button>
                                </div>
                              ) : (
                                <span className="text-xs text-gray-400">No prescription available</span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Pagination */}
                    {curebayReferralTotal > 9 && (
                      <div className="flex justify-center items-center gap-3 mt-6">
                        <button
                          disabled={curebayReferralPage === 1}
                          onClick={() => fetchCurebayReferralAppointments(curebayReferralPage - 1)}
                          className="px-4 py-1.5 rounded-full border border-gray-300 text-sm text-gray-600 disabled:opacity-40 hover:bg-gray-50 transition"
                        >
                          Previous
                        </button>
                        <span className="text-sm text-gray-500">
                          Page {curebayReferralPage} of {Math.ceil(curebayReferralTotal / 9)}
                          <span className="ml-2 text-gray-400">({curebayReferralTotal} total)</span>
                        </span>
                        <button
                          disabled={curebayReferralPage >= Math.ceil(curebayReferralTotal / 9)}
                          onClick={() => fetchCurebayReferralAppointments(curebayReferralPage + 1)}
                          className="px-4 py-1.5 rounded-full border border-gray-300 text-sm text-gray-600 disabled:opacity-40 hover:bg-gray-50 transition"
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </TabPane>

    

          {!disabledFeatures.includes("schedule-service") && (
          <TabPane
            tab={<span style={tabStyle.appointments}>Orders</span>}
            key="6"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end", // Align entire inner div to the right
                width: "100%", // Make it stretch full width
                padding: "8px 16px", // Optional spacing
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <Radio.Group
                  value={orderType}
                  onChange={(e) => setOrderType(e.target.value)}
                >
                  <Radio value="pharmacy">Medicine Orders</Radio>
                  <Radio value="Pathology">Pathology</Radio>
                  <Radio value="Radiology">Radiology</Radio>
                  <Radio value="Surgery">Surgery</Radio>
                </Radio.Group>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
                flexWrap: "wrap",
              }}
            >
              {/* <div
                style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
              >
                <DatePicker.RangePicker
                  onChange={(dates) => {
                    setDateRange(dates);
                  }}
                  style={{ width: 250 }}
                />
               
                <Button
                  onClick={() => {
                    setDateRange(null);
                  }}
                >
                  Clear
                </Button>
              </div> */}

              <div className="rounded-lg shadow-sm mb-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Order ID
                    </label>
                    <input
                      type="text"
                      name="orderId"
                      value={filters.orderId}
                      onChange={handleFilterChange}
                      className="w-full p-2 border border-gray-300 rounded-md"
                      placeholder="Enter Order ID"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      From Date
                    </label>
                    <input
                      type="date"
                      name="fromDate"
                      value={filters.fromDate}
                      onChange={handleFilterChange}
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      To Date
                    </label>
                    <input
                      type="date"
                      name="toDate"
                      value={filters.toDate}
                      onChange={handleFilterChange}
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  <div className="flex items-end space-x-2">
                    <button
                      onClick={handleSearch}
                      className="bg-[#003F6B] text-white px-4 py-2 rounded-md text-sm font-medium"
                    >
                      Search
                    </button>
                    <button
                      onClick={handleReset}
                      className="border border-[#003F6B] text-[#003F6B] px-4 py-2 rounded-md text-sm font-medium"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                // display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
              }}
            >
              {
                loading ? (
                  <div className="p-8 text-center">Loading orders...</div>
                ) : error ? (
                  <div className="p-8 text-center text-red-600">{error}</div>
                ) : orderType === "pharmacy" ? (
                  pharmacyOrders?.records?.length > 0 ? (
                    <div className="grid  grid-cols-3 gap-4 ">
                      {pharmacyOrders.records.map((order, index) =>
                        renderOrderCard(order, index)
                      )}
                    </div>
                  ) : (
                    <p>No pharmacy orders found</p>
                  )
                ) : orderType === "Pathology" ? (
                  labOrders.records?.length > 0 ? (
                    <div
                      className="grid  grid-cols-2 gap-4 "
                      // style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '20px', width: '50%' }}
                    >
                      {labOrders.records.map((order, index) => (
                        <div key={index}>{renderOrderCard2(order, index)}</div>
                      ))}
                    </div>
                  ) : (
                    <p>No lab orders found</p>
                  )
                ) : orderType === "Radiology" ? (
                  radiologyOrders.records?.length > 0 ? (
                    <div
                      className="grid  grid-cols-2 gap-4"
                      // style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '20px', width: '50%' }}
                    >
                      {radiologyOrders.records.map((order, index) => (
                        <div key={index}>{renderOrderCard2(order, index)}</div>
                      ))}
                    </div>
                  ) : (
                    <p>No lab orders found</p>
                  )
                ) : orderType === "Surgery" ? (
                  surgeryOrders.records?.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {surgeryOrders.records.map((order, index) =>
                        renderSurgeryOrderCard(order, index)
                      )}
                    </div>
                  ) : (
                    <p>No surgery orders found</p>
                  )
                ) : (
                  ""
                )

                // (
                //   labOrders.records?.length > 0 ? (
                //     <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '20px', width: '50%' }}>
                //       {labOrders.records.map((order, index) => (
                //         <div key={index} >
                //           {renderOrderCard2(order, index)}
                //         </div>
                //       ))
                //       }
                //     </div>
                //   ) : (
                //     <p>No lab orders found</p>
                //   )
                // )
              }
            </div>

            {isModalVisible && selectedOrder && (
              <OrderDetailsModal
                open={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                subtitle="Pharmacy Order Details"
                patientName={
                  selectedOrder.patientName ||
                  `${patient?.firstName || ""} ${patient?.lastName || ""}`.trim()
                }
                status={selectedOrder.enquiryTickets?.[0]?.ticketStatus}
                address={selectedOrder.address}
                addressLabel="Delivery Address"
                infoFields={[
                  {
                    label: "Drug Order ID",
                    value: selectedOrder.drugPrescriptions?.drugOrderId,
                    mono: true,
                  },
                  {
                    label: "Placed On",
                    value: selectedOrder.createdDate?.split("T")[0],
                  },
                  { label: "Mobile No", value: selectedOrder.patientMobileNo },
                ]}
              >
                <OrderDetailsSection title="Medicine Details">
                  <OrderDetailsTable>
                    <thead>
                      <tr>
                        <th className={`${orderTableHeadClass} text-left`}>Item Name</th>
                        <th className={`${orderTableHeadClass} text-center`}>Qty</th>
                        <th className={`${orderTableHeadClass} text-right`}>Unit Price</th>
                        <th className={`${orderTableHeadClass} text-right`}>Unit Price After Discount</th>
                        <th className={`${orderTableHeadClass} text-right`}>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedOrder.drugPrescriptions?.drugs?.map((drug, index) => (
                        <tr key={index}>
                          <td className={orderTableCellClass}>{drug.drugName}</td>
                          <td className={`${orderTableCellClass} text-center`}>{drug.quantity}</td>
                          <td className={`${orderTableCellClass} text-right`}>₹{drug.rate}</td>
                          <td className={`${orderTableCellClass} text-right`}>
                            ₹{drug.discountedAmount || 0}
                          </td>
                          <td className={`${orderTableCellClass} text-right`}>
                            ₹{(drug.rate * drug.quantity).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                      <tr className="bg-[#F9FAFB]">
                        <td colSpan="4" className={`${orderTableCellClass} text-right font-bold`}>
                          Total Amount
                        </td>
                        <td className={`${orderTableCellClass} text-right font-bold text-[#00B77E]`}>
                          ₹
                          {selectedOrder.drugPrescriptions?.drugs
                            ?.reduce((acc, drug) => acc + drug.rate * drug.quantity, 0)
                            .toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </OrderDetailsTable>
                </OrderDetailsSection>
              </OrderDetailsModal>
            )}
            {showModal && (
              <TrackingModal
                showModal={showModal}
                setShowModal={setShowModal}
                trackingInfo={trackingInfo}
              />
            )}
          </TabPane>
          )}
          <TabPane
            tab={<span style={tabStyle.appointments}>Family Members</span>}
            key="5"
          >
            {familyMembers.length === 0 ? (
              <p>No family members found.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {familyMembers.map((member, index) => (
                  <div
                    key={member.id || index}
                    className="bg-white rounded-lg shadow-md p-6 border border-gray-100"
                  >
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="bg-[#009e7c3d] rounded-full w-12 h-12 flex items-center justify-center">
                        <User className="w-6 h-6 text-[#00897b]" />
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900">
                          {member.salutation} {member.firstName} {member.lastName}
                        </h3>
                        <p className="text-sm text-gray-600">
                          {member.age} years • {member.gender}
                        </p>
                        <p className="text-xs text-gray-500">
                          DOB: {new Date(member.dob).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    
                    <div className="space-y-2 text-sm mb-4">
                      <div className="flex items-center space-x-2 text-gray-700">
                        <Phone className="w-4 h-4 text-[#00897b]" />
                        <span>{member.mobileNumber}</span>
                      </div>
                      <div className="flex items-center space-x-2 text-gray-700">
                        <MapPin className="w-4 h-4 text-[#00897b]" />
                        <span>{member.address}</span>
                      </div>
                      <div className="flex items-center space-x-2 text-gray-700">
                        <span className="text-xs bg-gray-100 px-2 py-1 rounded">
                          Patient Code: {member.patientCode}
                        </span>
                      </div>
                    </div>

                                         {member.chiefComplaint && (
                       <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                         <div className="flex items-center space-x-2 mb-2">
                           <span className="text-sm font-medium text-blue-700">
                             Chief Complaint
                           </span>
                         </div>
                         <div className="text-xs text-blue-600">
                           {member.chiefComplaint}
                         </div>
                       </div>
                     )}
                  </div>
                ))}
              </div>
            )}
          </TabPane>
          <TabPane
            tab={<span style={tabStyle.appointments}>Manage Address</span>}
            key="7"
          >
            <div className="flex justify-end mt-4">
              <button
                type="button"
                className="px-6 py-2 rounded-full border border-[#004276] text-[#fff] bg-[#004276] transition font-medium"
                onClick={() => {
                  setAddAddressModalOpen(true);
                  // Reset form fields for new address
                  setEditHouseNo("");
                  setEditAddress1("");
                  setEditPincode("");
                  setEditFetchedState("");
                  setEditFetchedCountry("India");
                  setEditErrors({});
                  setAddressToEdit(null);
                }}
              >
                Add Address
              </button>
            </div>
            <div className="py-6 px-2">
              {addressesLoading ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-600">Loading addresses...</span>
                </div>
              ) : patientAddresses.length > 0 ? (
                <div className="space-y-4">
                  {patientAddresses.map((address, index) => (
                    <div
                      key={address.id || index}
                      className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-200"
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          {/* Address Label */}
                          {/* <div className="flex items-center gap-3 mb-3">
                            <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm font-medium">
                              {address.label || (index === 0 ? "HOME" : index === 1 ? "WORK" : "OTHER")}
                            </span>
                          </div> */}
                          
                          {/* Patient Name */}
                          {/* <div className="text-lg font-semibold text-gray-900 mb-1">
                            {patient?.firstName} {patient?.lastName}
                          </div> */}
                          
                          {/* Phone Number */}
                          {/* <div className="text-gray-600 mb-2">
                            {patient?.mobileNumber || patient?.phoneNumber || "N/A"}
                          </div> */}
                          
                          {/* Full Address */}
                          <div className="text-gray-700 leading-relaxed text-base">
                            {address.address}, {address.landmark}, {address.pincode}, {address.state}, {address.country}
                          </div>
                        </div>
                        
                        {/* Actions Menu */}
                        <div className="ml-4 flex items-center">
                          <div className="relative">
                            <button
                              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors duration-200"
                              onClick={() => {
                                setAddressToEdit(address);
                                setEditHouseNo(address.address || "");
                                setEditAddress1(address.landmark || "");
                                setEditPincode(address.pincode || "");
                                setEditFetchedState(address.state || "");
                                setEditFetchedCountry(address.country || "India");
                                setEditErrors({});
                                setEditAddressModalOpen(true);
                              }}
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                            <button
                              className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-full transition-colors duration-200 ml-1"
                              onClick={() => {
                                setAddressToDelete(address);
                                setDeleteModalOpen(true);
                              }}
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <div className="text-gray-400 mb-4">
                    <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No addresses found</h3>
                  <p className="text-gray-500">This patient doesn't have any saved addresses yet.</p>
                </div>
              )}
            </div>
          </TabPane>
        </Tabs>

        {/* Edit Address Modal */}
        {editAddressModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h2 className="text-xl font-semibold text-gray-900">Edit Address</h2>
                <button
                  onClick={() => {
                    setEditAddressModalOpen(false);
                    setAddressToEdit(null);
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <div className="p-6">
                <div className="space-y-6">
                  {/* House no | Apartment name */}
                  <div>
                    <input
                      type="text"
                      placeholder="House no | Apartment name *"
                      className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                        editErrors.houseNo 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-blue-500'
                      }`}
                      value={editHouseNo}
                      onChange={(e) => setEditHouseNo(e.target.value)}
                      required
                    />
                    {editErrors.houseNo && (
                      <p className="text-red-500 text-sm mt-1">{editErrors.houseNo}</p>
                    )}
                  </div>

                  {/* Landmark */}
                  <div>
                    <input
                      type="text"
                      placeholder="Landmark *"
                      className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                        editErrors.address1 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-blue-500'
                      }`}
                      value={editAddress1}
                      onChange={(e) => setEditAddress1(e.target.value)}
                      required
                    />
                    {editErrors.address1 && (
                      <p className="text-red-500 text-sm mt-1">{editErrors.address1}</p>
                    )}
                  </div>

                  {/* Pincode and State */}
                  <div className="flex space-x-4">
                    <div className="flex-1">
                      <input
                        type="text"
                        placeholder="Pincode *"
                        className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                          editErrors.pincode 
                            ? 'border-red-500 focus:ring-red-500' 
                            : 'border-gray-300 focus:ring-blue-500'
                        }`}
                        value={editPincode}
                        maxLength={6}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, ''); // Only allow numbers
                          setEditPincode(value);
                          
                          // Clear error when user starts typing
                          if (editErrors.pincode) {
                            setEditErrors(prev => ({ ...prev, pincode: '' }));
                          }
                          
                          // Trigger API call when pincode is 6 digits
                          if (value.length === 6) {
                            console.log("Edit Pincode is 6 digits, calling API for:", value);
                            fetchEditAddressByPincode(value);
                          }
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        required
                      />
                      {editErrors.pincode && (
                        <p className="text-red-500 text-sm mt-1">{editErrors.pincode}</p>
                      )}
                    </div>
                    <div className="flex-1">
                      <input
                        type="text"
                        placeholder="State *"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                        value={editFetchedState}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Country */}
                  <div>
                    <input
                      type="text"
                      placeholder="Country *"
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                      value={editFetchedCountry}
                      readOnly
                    />
                  </div>

                  {/* Buttons */}
                  <div className="flex justify-center space-x-4 pt-6 border-t border-gray-200">
                    <button
                      onClick={() => {
                        setEditAddressModalOpen(false);
                        setAddressToEdit(null);
                      }}
                      className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gray-500 text-white hover:bg-gray-600 hover:shadow-lg"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleEditAddressSubmit}
                      className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white hover:shadow-lg hover:scale-105"
                    >
                      Update Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

{addAddressModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <h2 className="text-xl font-semibold text-gray-900">Add Address</h2>
                <button
                  onClick={() => {
                    setAddAddressModalOpen(false);
                   
                  }}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <div className="p-6">
                <div className="space-y-6">
                  {/* House no | Apartment name */}
                  <div>
                    <input
                      type="text"
                      placeholder="House no | Apartment name *"
                      className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                        editErrors.houseNo 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-blue-500'
                      }`}
                      value={editHouseNo}
                      onChange={(e) => setEditHouseNo(e.target.value)}
                      required
                    />
                    {editErrors.houseNo && (
                      <p className="text-red-500 text-sm mt-1">{editErrors.houseNo}</p>
                    )}
                  </div>

                  {/* Landmark */}
                  <div>
                    <input
                      type="text"
                      placeholder="Landmark *"
                      className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                        editErrors.address1 
                          ? 'border-red-500 focus:ring-red-500' 
                          : 'border-gray-300 focus:ring-blue-500'
                      }`}
                      value={editAddress1}
                      onChange={(e) => setEditAddress1(e.target.value)}
                      required
                    />
                    {editErrors.address1 && (
                      <p className="text-red-500 text-sm mt-1">{editErrors.address1}</p>
                    )}
                  </div>

                  {/* Pincode and State */}
                  <div className="flex space-x-4">
                    <div className="flex-1">
                      <input
                        type="text"
                        placeholder="Pincode *"
                        className={`w-full border rounded-lg px-4 py-3 text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 ${
                          editErrors.pincode 
                            ? 'border-red-500 focus:ring-red-500' 
                            : 'border-gray-300 focus:ring-blue-500'
                        }`}
                        value={editPincode}
                        maxLength={6}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, ''); // Only allow numbers
                          setEditPincode(value);
                          
                          // Clear error when user starts typing
                          if (editErrors.pincode) {
                            setEditErrors(prev => ({ ...prev, pincode: '' }));
                          }
                          
                          // Trigger API call when pincode is 6 digits
                          if (value.length === 6) {
                            console.log("Edit Pincode is 6 digits, calling API for:", value);
                            fetchEditAddressByPincode(value);
                          }
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        required
                      />
                      {editErrors.pincode && (
                        <p className="text-red-500 text-sm mt-1">{editErrors.pincode}</p>
                      )}
                    </div>
                    <div className="flex-1">
                      <input
                        type="text"
                        placeholder="State *"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                        value={editFetchedState}
                        readOnly
                      />
                    </div>
                  </div>

                  {/* Country */}
                  <div>
                    <input
                      type="text"
                      placeholder="Country *"
                      className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-500 bg-gray-50 focus:outline-none transition-all duration-200"
                      value={editFetchedCountry}
                      readOnly
                    />
                  </div>

                  {/* Buttons */}
                  <div className="flex justify-center space-x-4 pt-6 border-t border-gray-200">
                    <button
                      onClick={() => {
                        setAddAddressModalOpen(false);
                        
                      }}
                      className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gray-500 text-white hover:bg-gray-600 hover:shadow-lg"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleEditAddressSubmit}
                      className="py-3 px-8 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 bg-gradient-to-r from-[#004172] to-[#3cba84] text-white hover:shadow-lg hover:scale-105"
                    >
                      Add Address
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {deleteModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
              <div className="p-6">
                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 rounded-full">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">
                  Delete Address
                </h3>
                
                <p className="text-gray-600 text-center mb-6">
                  Are you sure you want to delete this address? This action cannot be undone.
                </p>
                
                {/* {addressToDelete && (
                  <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <p className="text-sm text-gray-700">
                      {addressToDelete.address}, {addressToDelete.landmark}, {addressToDelete.pincode}, {addressToDelete.state}, {addressToDelete.country}
                    </p>
                  </div>
                )} */}
                
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={() => {
                      setDeleteModalOpen(false);
                      setAddressToDelete(null);
                    }}
                    className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteAddress}
                    className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          open={docModalVisible}
          onCancel={() => setDocModalVisible(false)}
          width={800}
          footer={
            <div className="flex justify-end gap-4">
              
              <button
                onClick={() => setDocModalVisible(false)}
                className="px-4 py-2 border border-gray-400 text-gray-600 rounded hover:bg-gray-100"
              >
                Close
              </button>
            </div>
          }
        >
          {isPdf ? (
            <iframe
              src={docUrl}
              title="PDF Preview"
              className="w-full h-[80vh]"
              frameBorder="0"
            />
          ) : (
            <img
              src={docUrl}
              alt="Document Preview"
              className="w-full max-h-[80vh] object-contain"
            />
          )}
        </Modal>

        {isModalVisible2 && selectedOrder2 && (
          <OrderDetailsModal
            open={isModalVisible2}
            onClose={() => setIsModalVisible2(false)}
            subtitle="Lab Order Details"
            patientName={
              selectedOrder2.patientName ||
              `${patient?.firstName || ""} ${patient?.lastName || ""}`.trim()
            }
            status={selectedOrder2.enquiryTickets?.[0]?.ticketStatus}
            address={selectedOrder2.address}
            addressLabel="Delivery Address"
            infoFields={[
              {
                label: "Lab Order ID",
                value: selectedOrder2.labTests?.labOrderId,
                mono: true,
              },
              { label: "Mobile No", value: selectedOrder2.patientMobileNo },
            ]}
          >
            <OrderDetailsSection title="Test Details">
              <OrderDetailsTable>
                <thead>
                  <tr>
                    <th className={`${orderTableHeadClass} text-left`}>Test Name</th>
                    <th className={`${orderTableHeadClass} text-right`}>Unit Price</th>
                    <th className={`${orderTableHeadClass} text-right`}>Unit Price After Discount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOrder2.labTests?.labTests?.map((lab, index) => (
                    <tr key={index}>
                      <td className={orderTableCellClass}>{lab.labTestName}</td>
                      <td className={`${orderTableCellClass} text-right`}>
                        ₹{lab.amount ?? 0}
                      </td>
                      <td className={`${orderTableCellClass} text-right`}>
                        ₹{lab.discountedAmount ?? 0}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-[#F9FAFB]">
                    <td colSpan="2" className={`${orderTableCellClass} font-bold`}>
                      Total Amount
                    </td>
                    <td className={`${orderTableCellClass} text-right font-bold text-[#00B77E]`}>
                      ₹
                      {selectedOrder2.labTests?.labTests?.reduce(
                        (sum, lab) => sum + Number(lab.discountedAmount || 0),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </OrderDetailsTable>
            </OrderDetailsSection>
          </OrderDetailsModal>
        )}

        {isSurgeryModalVisible && selectedSurgeryOrder && (
          <OrderDetailsModal
            open={isSurgeryModalVisible}
            onClose={() => setIsSurgeryModalVisible(false)}
            subtitle="Surgery Order Details"
            patientName={
              selectedSurgeryOrder.patientName ||
              `${patient?.firstName || ""} ${patient?.lastName || ""}`.trim()
            }
            status={selectedSurgeryOrder.enquiryTickets?.[0]?.ticketStatus}
            address={selectedSurgeryOrder.address}
            infoFields={[
              { label: "Order ID", value: selectedSurgeryOrder.id, mono: true },
              {
                label: "Placed On",
                value: selectedSurgeryOrder.createdDate?.split("T")[0],
              },
              { label: "Mobile No", value: selectedSurgeryOrder.patientMobileNo },
            ]}
          >
            <SurgeryEnquiryCards
              surgeryEnquiry={selectedSurgeryOrder.surgeryEnquiry}
            />
          </OrderDetailsModal>
        )}

        {isModalVisible3 && (
          <TrackEnquiry
            isModalVisible2={isModalVisible3}
            setIsModalVisible2={setIsModalVisible3}
            ticketdata={ticketdata}
          />
        )}

        {curebayMedicineModalOpen && (() => {
          const selectedMedicineCount = Object.values(curebaySelectedDrugs).filter(
            (item) => item.checked
          ).length;
          const allSelected =
            curebayDrugList.length > 0 && selectedMedicineCount === curebayDrugList.length;

          return (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-[2px] p-4"
              onClick={() => !curebayMedicineAdding && setCurebayMedicineModalOpen(false)}
            >
              <div
                className="bg-white rounded-2xl w-full max-w-xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex items-center justify-between px-6 py-5 border-b border-slate-100 bg-gradient-to-r from-[#f8fbff] to-white">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="w-10 h-10 rounded-xl bg-[#004276]/10 flex items-center justify-center flex-shrink-0">
                      <Pill className="w-5 h-5 text-[#004276]" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-lg font-bold text-[#004276] mb-0">Select Medicines</h3>
                      <p className="text-xs text-slate-500 mt-0.5 mb-0">
                        Choose medicines and adjust quantity before adding to cart
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => !curebayMedicineAdding && setCurebayMedicineModalOpen(false)}
                    className="w-9 h-9 flex items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
                    aria-label="Close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>

                {!curebayMedicineLoading && curebayDrugList.length > 0 && (
                  <div className="flex items-center justify-between px-6 py-3 border-b border-slate-100 bg-slate-50/80">
                    <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                      {curebayDrugList.length} medicine{curebayDrugList.length === 1 ? "" : "s"} found
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        const nextChecked = !allSelected;
                        setCurebaySelectedDrugs((prev) => {
                          const updated = { ...prev };
                          Object.keys(updated).forEach((drugKey) => {
                            updated[drugKey] = { ...updated[drugKey], checked: nextChecked };
                          });
                          return updated;
                        });
                      }}
                      className="text-xs font-semibold text-[#004276] hover:text-[#003057]"
                    >
                      {allSelected ? "Deselect all" : "Select all"}
                    </button>
                  </div>
                )}

                <div className="flex-1 overflow-y-auto px-4 py-4">
                  {curebayMedicineLoading ? (
                    <div className="flex flex-col justify-center items-center py-20 gap-3">
                      <div className="animate-spin rounded-full h-9 w-9 border-2 border-[#004276]/20 border-t-[#004276]" />
                      <span className="text-sm text-slate-500">Loading medicines...</span>
                    </div>
                  ) : curebayDrugList.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-20 text-center px-6">
                      <div className="w-14 h-14 rounded-full bg-slate-100 flex items-center justify-center mb-3">
                        <Pill className="w-6 h-6 text-slate-400" />
                      </div>
                      <p className="text-sm font-semibold text-slate-700 mb-1">No medicines found</p>
                      <p className="text-xs text-slate-500 mb-0">
                        This prescription does not have any medicines to order.
                      </p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {curebayDrugList.map((drug, index) => {
                        const key = getCurebayDrugKey(drug);
                        const selected = curebaySelectedDrugs[key] || {
                          checked: false,
                          quantity: 1,
                          drug,
                        };
                        const isChecked = !!selected.checked;

                        return (
                          <div
                            key={key || index}
                            onClick={() => handleCurebayDrugToggle(key)}
                            className={`rounded-xl border p-4 cursor-pointer transition-all ${
                              isChecked
                                ? "border-[#004276]/30 bg-[#f4f8fc] shadow-sm"
                                : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
                            }`}
                          >
                            <div className="flex items-start gap-3">
                              <div
                                className={`mt-0.5 w-5 h-5 rounded-md border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                                  isChecked
                                    ? "border-[#004276] bg-[#004276]"
                                    : "border-slate-300 bg-white"
                                }`}
                              >
                                {isChecked && (
                                  <svg className="w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
                                    <path
                                      d="M2.5 6.2L5 8.7L9.5 3.8"
                                      stroke="currentColor"
                                      strokeWidth="1.8"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                )}
                              </div>

                              <div className="flex-1 min-w-0 pr-2">
                                <p className="font-bold text-[15px] text-slate-900 leading-snug mb-1">
                                  {drug.drugName}
                                </p>
                                {drug.composition && (
                                  <p className="text-sm text-slate-500 leading-relaxed mb-0">
                                    {drug.composition}
                                  </p>
                                )}
                              </div>

                              <div
                                className="flex flex-col items-end gap-1.5 flex-shrink-0"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                                  Qty
                                </span>
                                <div className="flex items-center rounded-lg border border-slate-200 bg-white overflow-hidden">
                                  <button
                                    type="button"
                                    onClick={() => handleCurebayDrugQuantityStep(key, -1)}
                                    disabled={!isChecked || selected.quantity <= 1}
                                    className="w-8 h-8 flex items-center justify-center text-slate-500 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
                                    aria-label="Decrease quantity"
                                  >
                                    <Minus className="w-3.5 h-3.5" />
                                  </button>
                                  <input
                                    type="number"
                                    min="1"
                                    value={selected.quantity}
                                    disabled={!isChecked}
                                    onChange={(e) =>
                                      handleCurebayDrugQuantityChange(key, e.target.value)
                                    }
                                    className="w-10 h-8 text-sm text-center font-semibold text-slate-800 border-x border-slate-200 focus:outline-none disabled:bg-slate-50 disabled:text-slate-400 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                  />
                                  <button
                                    type="button"
                                    onClick={() => handleCurebayDrugQuantityStep(key, 1)}
                                    disabled={!isChecked}
                                    className="w-8 h-8 flex items-center justify-center text-slate-500 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
                                    aria-label="Increase quantity"
                                  >
                                    <Plus className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                <div className="px-6 py-4 border-t border-slate-100 bg-white shadow-[0_-8px_24px_rgba(15,23,42,0.06)]">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-sm text-slate-500">Selected</span>
                    <span className="text-sm font-bold text-[#004276]">
                      {selectedMedicineCount} of {curebayDrugList.length}
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={handleCurebayAddMedicinesToCart}
                    disabled={
                      curebayMedicineLoading ||
                      curebayMedicineAdding ||
                      curebayDrugList.length === 0 ||
                      selectedMedicineCount === 0
                    }
                    className="w-full flex items-center justify-center gap-2 bg-[#004276] hover:bg-[#003057] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3.5 rounded-xl transition-colors shadow-md shadow-[#004276]/20"
                  >
                    {curebayMedicineAdding ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-2 border-white/30 border-t-white" />
                        Adding to cart...
                      </>
                    ) : (
                      <>
                        <ShoppingCart className="w-4 h-4" />
                        Add to Cart
                        
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    </OurLayouts>
  );
}
